const shortDateFormatter = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' });
const shortDateWithYearFormatter = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});
const relativeTimeFormatter = new Intl.RelativeTimeFormat('en-GB', { numeric: 'auto' });

/** "24 Sep", or "24 Sep 2027" when the date falls outside the current year. */
export function formatShortDate(date: Date, now: Date): string {
  const sameYear = date.getFullYear() === now.getFullYear();
  return (sameYear ? shortDateFormatter : shortDateWithYearFormatter).format(date);
}

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;

/**
 * "just now", "5 minutes ago", "yesterday", "3 days ago", "2 weeks ago", then a
 * short date once a relative phrase stops being easier to read than the date.
 */
export function formatRelativeTime(date: Date, now: Date): string {
  const elapsed = Math.max(0, now.getTime() - date.getTime());
  if (elapsed < MINUTE_MS) {
    return 'just now';
  }
  if (elapsed < HOUR_MS) {
    return relativeTimeFormatter.format(-Math.floor(elapsed / MINUTE_MS), 'minute');
  }
  if (elapsed < DAY_MS) {
    return relativeTimeFormatter.format(-Math.floor(elapsed / HOUR_MS), 'hour');
  }
  if (elapsed < WEEK_MS) {
    return relativeTimeFormatter.format(-Math.floor(elapsed / DAY_MS), 'day');
  }
  if (elapsed < 5 * WEEK_MS) {
    return relativeTimeFormatter.format(-Math.floor(elapsed / WEEK_MS), 'week');
  }
  return formatShortDate(date, now);
}
